export default "__VITE_ASSET__DqBmlUDI__"